module.exports = __webpack_public_path__ + "static/media/Tentacle_Obey_Activate.115b8018.mp3";